import { logError } from '@zg-rentals/log-error';
import { identify } from '@zillow/universal-analytics';
import { getAnalyticsErrorType, getCookie, parseEncodedZuid } from './utils';

// some non-Zillow brands might have to pass a user ID explicitly
// whereas on Zillow, we can safely rely on the zjs_user_id cookie
// an explicit `null` would mean the user is logged out, no arg means rely on zillow cookies
export function identifyUser(userId?: string | null) {
  try {
    const userIdToUser = userId === undefined ? parseEncodedZuid(getCookie('zjs_user_id')) : userId;
    identify(userIdToUser || '');
  } catch (error) {
    logError({
      error,
      errorType: getAnalyticsErrorType('IdentifyUserError'),
    });
  }
}
